import React from "react";

const About = () => {
    return(
        <div>
                 <header className>
        <nav className="navbar navbar-expand-lg">
          <div className="container">
          <img src="assets/images/la-logo-240px.png" className="la-logo" alt=""></img>
            <a className="navbar-brand" href="index.html"><h2>Lakshan Associates</h2></a>
            <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
              <span className="navbar-toggler-icon" />
            </button>
            <div className="collapse navbar-collapse" id="navbarResponsive">
              <ul className="navbar-nav ml-auto">
                <li className="nav-item">
                  <a className="nav-link" href="/home">Home
                    <span className="sr-only"></span>
                  </a>
                </li>
                <li className="nav-item active">
                  <a className="nav-link" href="/about">About Us</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="/ourservices">Our Services</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="/ourfacilities">Our Facilities</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="/contactus">Contact Us</a>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </header>
        {/* Page Content */}
        <div className="page-heading header-text">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <h1>About Us</h1>
                <span>We have over 6 years of experience</span>
              </div>
            </div>
          </div>
    </div> 
       
       
        <div className="more-info about-info">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="more-info-content">
                  <div className="row">
                    <div className="col-md-6 align-self-center">
                      <div className="right-content ">
                       
                        <span>Who we are</span>
                        <h2>Get to know about <em>our company</em></h2>
                        <div className="desc">
                        <p>
                          Lakshan Associates is a licensed provider of waste management and recycling solutions with fully equipped facility to handle all sort of scraps.<br /><br />
                          Our core business include buying and selling of various kinds of scrap such as Waste Cortons, Wooden Wastes, General Wastes, Plastic Wastes, Aluminium, copper, chillers, stainless steel, brass, cables, scrap iron such as sheet piles, cutting plates, rebar, machinery, zinc, etc.<br /><br />
                          We also provide Transports, Demolition, Disposal and Clearing for buildings and heavy industries. With decades of knowledge and experiences, we have a dedicated team of experiences and knowledgeable workers who can solve your problems at the least provided time. With our own vehicles from 5 tons to heavy duty forklifts we complete our job promptly.<br /><br />
                          Lakshan Associates believes in not only providing the best price and service but also in making it easier for customers to sell their scraps at their convenience.
                        </p></div>
                         {/* <div className="readMore"><a href=''><span className="readMore">Read more</span><span className="readLess">Read less</span></a></div>  */}
                        
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="left-image">
                        <img src="assets/images/about-image.jpg" alt="" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>  



  {/* <div className="outer">
        <h1>Read more unit</h1>
        <blockquote>A stripped simple "read more/read less" unit. Feel free to use! The link <code>read more</code> will toggle <code>readingMore</code> class on <code>.desc</code>, thats it.</blockquote>
        <div className="desc">
          <div className="col">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quod neque eaque fuga culpa doloribus adipisci vel explicabo! Nihil ipsa commodi quae voluptates laudantium fugit nam. Itaque veniam iure aliquid harum!
            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quod neque eaque fuga culpa doloribus adipisci vel explicabo! Nihil ipsa commodi quae voluptates laudantium fugit nam. Itaque veniam iure aliquid harum!</p>
          </div>
          <div className="col">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quod neque eaque fuga culpa doloribus adipisci vel explicabo! Nihil ipsa commodi quae voluptates laudantium fugit nam. Itaque veniam iure aliquid harum!</div>
          <div className="overlay" />
        </div>
        <div className="readMore"><a href><span className="readMore">Read more</span><span className="readLess">Read less</span></a>
        </div>
    </div>  */}

    {/* What we deals with */}

    
    <div className="whatwedeals">
    <div className="section-heading">
                  <h2>What <em>We Deals With</em></h2>
                  <span>We provide the best services for our customers</span>
                </div>
    <div className="wrapper">
        <div className="box">
          <div id="bg1" className="img-box"></div>
          <div className="stt-box">
            <h2 className="tt-box">Procuring all kinds of scraps</h2>
          </div>
        </div>
        <div className="box">
          <div id="bg2" className="img-box" />
          <div className="stt-box">
            <h2 className="tt-box">Machinery scraps and asset scraps</h2>
          </div>
        </div>
        <div className="box">
          <div id="bg3" className="img-box" />
          <div className="stt-box">
            <h2 className="tt-box">Manpower contracts</h2>
          </div>
        </div>  
      </div>

      <div className="wrapper">
        <div className="box">
          <div id="bg4" className="img-box" />
          <div className="stt-box">
            <h2 className="tt-box">Transports</h2>
          </div>
        </div>
        <div className="box">
          <div id="bg5" className="img-box" />
          <div className="stt-box">
            <h2 className="tt-box">Various Cranes, Earth Moving</h2>
          </div>
        </div>
        <div className="box">
          <div id="bg6" className="img-box" />
          <div className="stt-box">
            <h2 className="tt-box">Boom lifts, Fork lifts</h2>
          </div>
        </div>
      </div>
      </div>


 {/* Where we procuring scraps */}

 <div className="whatwedeals">
    <div className="section-heading">
                  <h2>Where we <em>procuring scraps</em></h2>
                  <span>Here is the list of our key customers</span>
                </div>
    <div className="wrapper">
        <div className="box">
          <div id="bg7" className="img-box"></div>
          <div className="stt-box">
            <h2 className="tt-box">Daimler India Commercial Vehicles</h2>
          </div>
        </div>
        <div className="box">
          <div id="bg8" className="img-box" />
          <div className="stt-box">
            <h2 className="tt-box">Ramky enviro engineering ltd</h2>
          </div>
        </div>
        <div className="box">
          <div id="bg9" className="img-box" />
          <div className="stt-box">
            <h2 className="tt-box">Saint Gobain Glass India Ltd</h2>
          </div>
        </div>  
      </div>

      <div className="wrapper">
        <div className="box">
          <div id="bg10" className="img-box" />
          <div className="stt-box">
            <h2 className="tt-box">Modine Thermal Systems Pvt Ltd</h2>
          </div>
        </div>
        <div className="box">
          <div id="bg11" className="img-box" />
          <div className="stt-box">
            <h2 className="tt-box">ETA Engineering Pvt Ltd</h2>
          </div>
        </div>
        <div className="box">
          <div id="bg12" className="img-box" />
          <div className="stt-box">
            <h2 className="tt-box">Korea Fuel Tech Ltd</h2>
          </div>
        </div>
      </div>
      </div>

      {/* Our Monthly Capacity */}
      <section className="container">
     
    <h3 className="table-text">MONTHLY MATERIAL HANDLING CAPACITY &amp; PRODUCTION REPORT</h3>
    <table border="1" className="center">
    <tr>
       <th><i className="fa fa-arrow-circle-right"></i>Cartons Scraps </th>
       <td>200 MT</td>
    </tr>

    <tr>
      <th><i className="fa fa-arrow-circle-right"></i>Wooden Scraps</th>
      <td>275 MT</td>
    </tr>

    <tr>
      <th><i className="fa fa-arrow-circle-right"></i>General Waste Scraps (packing wastes)</th>
      <td>40 MT</td>
    </tr>

    <tr>
      <th><i className="fa fa-arrow-circle-right"></i>Plastic Scraps </th>
      <td>50 MT</td>
    </tr>

    <tr>
      <th><i className="fa fa-arrow-circle-right"></i>MS Scraps</th>
      <td>250 MT</td>
    </tr>

    <tr>
      <th><i className="fa fa-arrow-circle-right"></i>Aluminium Scraps</th>
      <td>10 MT</td>
    </tr>

    <tr>
      <th><i className="fa fa-arrow-circle-right"></i>Rubbish Scraps</th>
      <td>150 MT</td>
    </tr>

    <tr>
      <th><i className="fa fa-arrow-circle-right"></i>Glass Scrap</th>
      <td>150 MT</td>
    </tr>

    <tr>
      <th><i className="fa fa-arrow-circle-right"></i>Rubber scraps</th>
      <td>10 MT</td>
    </tr>

    <tr>
      <th><i className="fa fa-arrow-circle-right"></i>Copper Scraps</th>
      <td>0.5 MT</td>
    </tr>

    <tr>
      <th><i className="fa fa-arrow-circle-right"></i>Other municipality rubbish</th>
      <td>100 MT</td>
    </tr>
  </table>
  </section>





        <div className="team">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="section-heading">
                  <h2>Our team <em>members</em></h2>
                  <span>Suspendisse a ante in neque iaculis lacinia</span>
                </div>
              </div>
              <div className="col-md-4">
                <div className="team-item">
                  <img src="assets/images/team_01.jpg" alt="" />
                  <div className="down-content">
                    <h4>William Smith</h4>
                    <span>Co-Founder</span>
                    <p>In sem sem, dapibus non lacus auctor, ornare sollicitudin lacus. Aliquam ipsum urna, semper quis.</p>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="team-item">
                  <img src="assets/images/team_02.jpg" alt="" />
                  <div className="down-content">
                    <h4>Mary Houston</h4>
                    <span>Chief Marketing Officer</span>
                    <p>In sem sem, dapibus non lacus auctor, ornare sollicitudin lacus. Aliquam ipsum urna, semper quis.</p>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="team-item">
                  <img src="assets/images/team_03.jpg" alt="" />
                  <div className="down-content">
                    <h4>Paul Walker</h4>
                    <span>Financial Analyst</span>
                    <p>In sem sem, dapibus non lacus auctor, ornare sollicitudin lacus. Aliquam ipsum urna, semper quis.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </div>

        
         {/* <div className="container">
            <div className="row">
             <div className="col-md-6">
                <div className="left-content">
                  <span>Lorem ipsum dolor sit amet</span>
                  <h2>Our solutions for your <em>business growth</em></h2>
                  <p>Pellentesque ultrices at turpis in vestibulum. Aenean pretium elit nec congue elementum. Nulla luctus laoreet porta. Maecenas at nisi tempus, porta metus vitae, faucibus augue. 
                    <br /><br />Fusce et venenatis ex. Quisque varius, velit quis dictum sagittis, odio velit molestie nunc, ut posuere ante tortor ut neque.</p>
                    <a href className="filled-button">Read More</a> 
                </div>
              </div> 
              <div className="col-md-6 align-self-center">
                <div className="row">
                  <div className="col-md-6">
                    <div className="count-area-content">
                      <div className="count-digit">945</div>
                      <div className="count-title">Work Hours</div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="count-area-content">
                      <div className="count-digit">1280</div>
                      <div className="count-title">Great Reviews</div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="count-area-content">
                      <div className="count-digit">578</div>
                      <div className="count-title">Projects Done</div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="count-area-content">
                      <div className="count-digit">26</div>
                      <div className="count-title">Awards Won</div>
                    </div>
                  </div> 
                </div>
              </div> 
             </div> 
          </div> */}
        </div> 
        
    )
}

export default About;